// 字段名与「01.医疗模块.json」保持一致，供页面展示及接口数据规范化共用。
export const MEDICINE_TYPES = [
    { field: 'chineseMedicineTop10', title: '中药' },
    { field: 'westernMedicineTop10', title: '西药' },
    { field: 'formulaTop10', title: '方剂' },
    { field: 'chinesePatentMedicineTop10', title: '中成药' },
    { field: 'foodTop10', title: '食品' },
    { field: 'medicinalSubstanceTop10', title: '药用物质' },
];
export const TREATMENT_TYPES = [
    { field: 'treatmentPrincipleTop10', title: '治则治法' },
    { field: 'therapyTop10', title: '疗法' },
    { field: 'integratedTcmWesternTop10', title: '中西医结合疗法' },
    { field: 'acupunctureTop10', title: '针灸疗法' },
    { field: 'massageTop10', title: '按摩' },
    { field: 'acupointTop10', title: '穴位' },
    { field: 'meridianTop10', title: '经络' },
    { field: 'surgeryOperationTop10', title: '手术操作' },
];
export const PATHOGENESIS_TYPES = [
    { field: 'tcmEtiologyPathogenesisTop10', title: '中医病因病机' },
    { field: 'zangfuTop10', title: '脏腑' },
    { field: 'zangfuFunctionTop10', title: '脏腑功能' },
    { field: 'yinYangTop10', title: '阴阳' },
    { field: 'fiveElementsTop10', title: '五行' },
    { field: 'tcmTheoryTop10', title: '中医理论' },
    { field: 'physiologicalPhenomenonTop10', title: '生理现象' },
    { field: 'physiologicalFunctionTop10', title: '生理功能' },
];
export const TCM_DIAGNOSIS_TYPES = [
    { field: 'syndromeDifferentiation', title: '辨证' },
    { field: 'syndrome', title: '证候' },
    { field: 'tongueImage', title: '舌象' },
    { field: 'pulseCondition', title: '脉象' },
    { field: 'zangfuFunction', title: '脏腑功能' },
];
export const WESTERN_DIAGNOSIS_TYPES = [
    { field: 'symptomsSigns', title: '症状体征' },
    { field: 'examinationOperation', title: '检查操作' },
    { field: 'laboratoryTest', title: '实验室检查' },
];

const asArray = (value) => Array.isArray(value) ? value : [];

// 接收业务响应中的 data。保留后端名称、数值与排序，不补造缺失数据。
export function normalizeDoctorData(value) {
    const data = value || {};
    const sankey = data.sankey || {};
    const graph = data.treatmentKnowledgeGraph || {};
    const stacked = (data.pathogenesisStackedBar && data.pathogenesisStackedBar.data) || {};
    const result = {
        diseaseName: data.diseaseName || '',
        sankey: { data: asArray(sankey.data), links: asArray(sankey.links) },
        treatmentKnowledgeGraph: { nodes: asArray(graph.nodes), edges: asArray(graph.edges) },
        pathogenesisStackedBar: {
            data: { title: stacked.title || '病因病机堆叠条形图', xAxis: asArray(stacked.xAxis), series: asArray(stacked.series) },
        },
    };
    [...MEDICINE_TYPES, ...TREATMENT_TYPES, ...PATHOGENESIS_TYPES,
        ...TCM_DIAGNOSIS_TYPES, ...WESTERN_DIAGNOSIS_TYPES].forEach(({ field }) => {
        result[field] = asArray(data[field]);
    });
    return result;
}
